var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cadastro-page-header"},[_c('h1',{staticClass:"cadastro-page-header__title"},[_vm._v(_vm._s(_vm.titulo))]),(_vm.subtitulo)?_c('p',{staticClass:"cadastro-page-header__subtitle"},[_vm._v(_vm._s(_vm.subtitulo))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }